<template>
  <div class="w-full" :style="{ maxWidth: maxWidth }">
    <div class="relative h-2">
      <div class="absolute h-2 w-full rounded bg-gray-200"></div>

      <div
        class="absolute h-2 rounded bg-secondary"
        :style="{
          left: minPercent + '%',
          width: maxPercent - minPercent + '%'
        }"
      ></div>

      <input
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="modelValue.min"
        @input="updateMin($event.target.value)"
        class="range-slider"
      />

      <input
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="modelValue.max"
        @input="updateMax($event.target.value)"
        class="range-slider"
      />
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    modelValue: {
      type: Object,
      required: true,
      validator: (value) =>
        value.hasOwnProperty('min') && value.hasOwnProperty('max')
    },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 1000 },
    step: { type: Number, default: 10 },
    prefix: { type: String, default: '$' },
    maxWidth: { type: String, default: '400px' }
  });

  const emit = defineEmits(['update:modelValue']);

  const minPercent = computed(
    () => ((props.modelValue.min - props.min) / (props.max - props.min)) * 100
  );
  const maxPercent = computed(
    () => ((props.modelValue.max - props.min) / (props.max - props.min)) * 100
  );

  const updateMin = (value) => {
    const newMin = Math.min(parseInt(value), props.modelValue.max);
    emit('update:modelValue', { ...props.modelValue, min: newMin });
  };

  const updateMax = (value) => {
    const newMax = Math.max(parseInt(value), props.modelValue.min);
    emit('update:modelValue', { ...props.modelValue, max: newMax });
  };
</script>

<style scoped>
  .range-slider {
    position: absolute;
    width: 100%;
    height: 8px;
    background: transparent;
    pointer-events: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none;
  }

  .range-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    pointer-events: auto;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: white;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(var(--tw-secondary-color)) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  .range-slider::-moz-range-thumb {
    pointer-events: auto;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: white;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(var(--tw-secondary-color)) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
</style>
